<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado borderTop v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">PREFERENCIA TARIFÁRIA</h2>
    <QuadroAlerta
      v-if="!!imposto.dados.length"
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :key="getRenderKey"
      :borderTop="!imposto.dados.length || !exibeAlerta"
      :titulo="imposto.nome"
      :classe="imposto.classe"
    >
      <div v-if="imposto.dados.length == 0">
        <ImpostoSemResultado :titulo="imposto.nome" />
      </div>

      <div class="registro-container">
        <div v-if="!selecionouPreferenciaTarifaria">
          <div class="preferencia-content" v-for="(subimposto, index) in imposto.dados">
            <RadioButton
              v-if="imposto.dados.length > 1"
              :classe="imposto.classe"
              :seleciona="seleciona"
              :imposto="subimposto"
              :name="'radio'"
            />
            <RegistrosPreferenciaTarifaria
              class="registro-preferencia-container"
              :subimposto="subimposto"
              :imposto="imposto"
            />
          </div>
        </div>

        <div v-else class="preferencia-content">
          <EditButton v-if="imposto.dados.length > 1" :edita="edita" :classe="imposto.classe" />
          <RegistrosPreferenciaTarifaria :subimposto="impostoSelecionado" :imposto="imposto" />
        </div>
      </div>
    </QuadroPrincipal>
  </div>
</template>

<script>
import AcordoComercial from "@/components/AcordoComercial/AcordoComercial.vue";
import EditButton from "@/components/Button/EditButton.vue";
import ImpostoSemResultado from "@/components/ImpostoSemResultado/ImpostoSemResultado.vue";
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import RegistrosPreferenciaTarifaria from "@/components/RegistrosPreferenciaTarifaria/RegistrosPreferenciaTarifaria.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "PreferenciaTarifaria",

  props: {
    id: String | Number,
    tributoAtivo: String,
    buscarImposto: Function,
    exibeImposto: Boolean,
    dadosForm: Array | Object
  },

  components: {
    AcordoComercial,
    EditButton,
    ImpostoSemResultado,
    LoadingResultado,
    MensagemErro,
    MultiplosSemResultado,
    QuadroAlerta,
    QuadroPrincipal,
    RadioButton,
    RegistrosPreferenciaTarifaria
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "PREFERENCIA TARIFÁRIA",
      nomeImposto: "preferencia_tarifaria",
      imposto: null,
      impostoSelecionado: {},
      selecionouPreferenciaTarifaria: false,
      erro: false,
      ativarLoading: false
    };
  },

  async created() {
    this.setSelecao({ selecionouPreferenciaTarifaria: this.selecionouPreferenciaTarifaria });
    this.ativarLoading = true;
    if (this.tributoAtivo == this.nomeImposto && !this.imposto && this.exibeImposto) {
      [this.imposto] = await this.buscarImposto({ imposto: this.nomeImposto, idCenario: this.id });
    }
    this.ativarLoading = false;
  },

  updated() {
    if (this.selecionouPreferenciaTarifaria) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      this.ativarLoading = true;
      if (newValue == this.nomeImposto && !this.imposto && this.exibeImposto) {
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
      }
      this.ativarLoading = false;
    },

    ativarLoading() {
      this.$emit("loading", this.ativarLoading);
    },

    selecionouPreferenciaTarifaria() {
      this.setSelecao({ selecionouPreferenciaTarifaria: this.selecionouPreferenciaTarifaria });
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),

    impressaoLog() {
      let log = {
        logPreferenciaTarifaria: {
          imposto: this.impostoSelecionado
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    seleciona(imposto) {
      this.impostoSelecionado = imposto;
      this.selecionouPreferenciaTarifaria = true;
    },

    edita() {
      this.impostoSelecionado = {};
      this.selecionouPreferenciaTarifaria = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.registro-container {
  display: flex;
  flex-direction: column;
}

.registro-preferencia-container {
  margin-bottom: 1rem;
}

.preferencia-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
</style>
